import { SUPPORTED_ATTACHMENT_MIME_TYPES } from "src/services/api/chat/attachments"
import { PendingAttachment } from "src/types/chat"
import { AttachmentCard } from "../AttachmentCard"

interface IAttachmentPreviewProps {
    attachment: PendingAttachment
    onRemove: (id: string) => void
}

const AttachmentPreview = ({ attachment, onRemove }: IAttachmentPreviewProps) => (
    <AttachmentCard
        filename={attachment.filename}
        typeLabel={SUPPORTED_ATTACHMENT_MIME_TYPES[attachment.payload.mime_type] ?? "Arquivo"}
        sizeBytes={attachment.sizeBytes}
        onRemove={() => onRemove(attachment.id)}
    />
)

export { AttachmentPreview }
